import { render, staticRenderFns } from "./QASession.vue?vue&type=template&id=65d0dfdf&scoped=true&"
import script from "./QASession.vue?vue&type=script&lang=js&"
export * from "./QASession.vue?vue&type=script&lang=js&"
import style0 from "./QASession.vue?vue&type=style&index=0&id=65d0dfdf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d0dfdf",
  null
  
)

export default component.exports